<template>
  <div class="party-building-page">
    <!-- Hero Banner - 红色党建主题 -->
    <section class="party-hero">
      <div class="hero-bg">
        <img src="/static/dj.png" alt="党建工作">
      </div>

      <!-- 内容区 (首屏入场CSS动画) -->
     <!-- <div class="hero-content">
        <div class="hero-title-bar reveal-elem" style="--d:.05s"></div>
        <h1 class="hero-title reveal-elem" style="--d:.25s">党建工作</h1>
        <div class="hero-divider reveal-elem" style="--d:.5s"></div>
        <p class="hero-en-title reveal-elem" style="--d:.7s">PARTY BUILDING WORK</p>
      </div> -->
    </section>

    <!-- 面包屑导航 -->
    <section class="breadcrumb-section">
      <div class="container">
        <div class="breadcrumb" data-aos="fade-right" data-aos-duration="600">
          <router-link to="/party-building" class="crumb-link active">党建工作</router-link>
          <span class="crumb-sep">|</span>
          <span class="crumb-current">党建工作</span>
        </div>
      </div>
    </section>

    <!-- 主要内容区 -->
    <section class="content-section">
      <div class="container">
        <!-- 推荐/置顶文章 - 外层AOS、内层无:class避免冲突 -->
        <div data-aos="zoom-in" data-aos-duration="800" data-aos-easing="ease-out-cubic">
          <div class="featured-article">
            <div class="featured-image">
              <img src="/static/xwdt.png" alt="携手央企 共赢未来">
              <div class="image-shine"></div>
            </div>
            <div class="featured-content">
              <h3 class="featured-title">携手央企 共赢未来！</h3>
              <p class="featured-excerpt">
                为深化央地企业合作、整合行业优质资源，3月24日，葛洲坝集团项目管理有限公司周总、于总一行莅临新恒丰咨询集团开展深度交流座谈。
              </p>
              <div class="featured-footer">
                <div class="featured-date">
                  <i class="el-icon-time"></i>
                  <span>2036年5月26日</span>
                </div>
                <button class="featured-btn">
                  <i class="el-icon-arrow-right"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- 文章列表 - 外层放AOS和延时，内层用ref+命令式classList -->
        <div class="article-list">
          <div
            v-for="(item, index) in articleList"
            :key="item.id"
            :data-aos-delay="index * 110"
            data-aos="fade-up"
            data-aos-duration="700"
          >
            <div class="article-item" ref="articleItems" :data-idx="index">
              <div class="article-date-block">
                <span class="date-day">{{ item.day }}</span>
                <span class="date-ym">{{ item.yearMonth }}</span>
              </div>
              <div class="article-info">
                <h4 class="article-title">{{ item.title }}</h4>
                <p class="article-excerpt">{{ item.excerpt }}</p>
              </div>
              <div class="article-action">
                <i class="el-icon-right"></i>
              </div>
            </div>
          </div>
        </div>

        <!-- 分页 -->
        <div class="pagination-wrap" data-aos="fade-up" data-aos-delay="150" data-aos-duration="600">
          <span class="total-text">共{{ totalCount }}条</span>
          <button class="page-btn" :disabled="currentPage === 1" @click="changePage(currentPage - 1)">
            上一页
          </button>
          <button
            v-for="p in totalPages"
            :key="p"
            class="page-num"
            :ref="'pageNum' + p"
            @click="changePage(p)"
          >
            {{ p }}
          </button>
          <button class="page-btn" :disabled="currentPage === totalPages" @click="changePage(currentPage + 1)">
            下一页
          </button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'PartyBuilding',
  data() {
    return {
      currentPage: 1,
      totalCount: 15,
      pageSize: 6,
      articleList: [
        { id: 1, day: '26', yearMonth: '2036-05', title: '新恒丰咨询集团获评"河南省招标投标协会25年度诚信自律建设优秀单位"', excerpt: '近日，河南省招标投标协会正式印发《关于表彰2025年度诚信自律建设优秀单位、优秀个人的决定》（豫招协[2026]001号），新恒丰咨询集团有限公司获评"2025年度诚信自律建设优秀单位"，孙瑞娜同志获评"2025...' },
        { id: 2, day: '26', yearMonth: '2036-05', title: '新恒丰咨询集团获评"河南省招标投标协会25年度诚信自律建设优秀单位"', excerpt: '近日，河南省招标投标协会正式印发《关于表彰2025年度诚信自律建设优秀单位、优秀个人的决定》（豫招协[2026]001号），新恒丰咨询集团有限公司获评"2025年度诚信自律建设优秀单位"，孙瑞娜同志获评"2025...' },
        { id: 3, day: '26', yearMonth: '2036-05', title: '新恒丰咨询集团获评"河南省招标投标协会25年度诚信自律建设优秀单位"', excerpt: '近日，河南省招标投标协会正式印发《关于表彰2025年度诚信自律建设优秀单位、优秀个人的决定》（豫招协[2026]001号），新恒丰咨询集团有限公司获评"2025年度诚信自律建设优秀单位"，孙瑞娜同志获评"2025...' },
        { id: 4, day: '26', yearMonth: '2036-05', title: '新恒丰咨询集团获评"河南省招标投标协会25年度诚信自律建设优秀单位"', excerpt: '近日，河南省招标投标协会正式印发《关于表彰2025年度诚信自律建设优秀单位、优秀个人的决定》（豫招协[2026]001号），新恒丰咨询集团有限公司获评"2025年度诚信自律建设优秀单位"，孙瑞娜同志获评"2025...' },
        { id: 5, day: '26', yearMonth: '2036-05', title: '新恒丰咨询集团获评"河南省招标投标协会25年度诚信自律建设优秀单位"', excerpt: '近日，河南省招标投标协会正式印发《关于表彰2025年度诚信自律建设优秀单位、优秀个人的决定》（豫招协[2026]001号），新恒丰咨询集团有限公司获评"2025年度诚信自律建设优秀单位"，孙瑞娜同志获评"2025...' },
        { id: 6, day: '26', yearMonth: '2036-05', title: '新恒丰咨询集团获评"河南省招标投标协会25年度诚信自律建设优秀单位"', excerpt: '近日，河南省招标投标协会正式印发《关于表彰2025年度诚信自律建设优秀单位、优秀个人的决定》（豫招协[2026]001号），新恒丰咨询集团有限公司获评"2025年度诚信自律建设优秀单位"，孙瑞娜同志获评"2025...' }
      ]
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.totalCount / this.pageSize)
    }
  },
  mounted() {
    // 使用 classList 命令式添加样式类（避免与 AOS aos-animate 冲突）
    this.$nextTick(() => {
      this.markFirstItem()
      this.updatePageActive()
    })
  },
  watch: {
    currentPage() {
      this.$nextTick(() => this.updatePageActive())
    }
  },
  methods: {
    markFirstItem() {
      const items = this.$refs.articleItems || []
      items.forEach((el, i) => {
        if (!el) return
        if (i === 0) {
          el.classList.add('first')
          const db = el.querySelector('.article-date-block')
          const ac = el.querySelector('.article-action')
          if (db) db.classList.add('highlight')
          if (ac) ac.classList.add('active')
        }
      })
    },
    updatePageActive() {
      for (let p = 1; p <= this.totalPages; p++) {
        const ref = this.$refs['pageNum' + p]
        const el = Array.isArray(ref) ? ref[0] : ref
        if (!el) continue
        if (p === this.currentPage) el.classList.add('active')
        else el.classList.remove('active')
      }
    },
    changePage(p) {
      if (p < 1 || p > this.totalPages) return
      this.currentPage = p
      const section = document.querySelector('.content-section')
      if (section) {
        const top = section.offsetTop - 80
        window.scrollTo({ top, behavior: 'smooth' })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.party-building-page {
  min-height: 100vh;
  background: #fff;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* ===== Hero Banner - 红色党建主题 ===== */
.party-hero {
  position: relative;
  height: 380px;
  overflow: hidden;
  background: #8B0000;
}

/* Banner背景图 - 与其他页面一致 */
.hero-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    opacity: 0;
    transform: scale(1.08);
    animation: heroBgReveal 1.2s cubic-bezier(.2,.8,.2,1) forwards;
  }
}

@keyframes heroBgReveal {
  0% { opacity: 0; transform: scale(1.08); }
  100% { opacity: 1; transform: scale(1); }
}

/* 首屏入场 - Banner标题元素通用CSS动画 */
.reveal-elem {
  opacity: 0;
  transform: translateY(26px);
  animation: heroReveal 0.9s cubic-bezier(.22,.8,.25,1) forwards;
  animation-delay: var(--d, 0s);
}

@keyframes heroReveal {
  0% { opacity: 0; transform: translateY(26px); filter: blur(4px); }
  60% { filter: blur(0); }
  100% { opacity: 1; transform: translateY(0); filter: blur(0); }
}

/* Banner内容 */
.hero-content {
  position: relative;
  z-index: 5;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 18%;
}

.hero-title-bar {
  width: 80px;
  height: 4px;
  background: linear-gradient(90deg, #f5d06a, #dc2626);
  margin-bottom: 24px;
  border-radius: 2px;
}

.hero-title {
  font-size: 54px;
  font-weight: 800;
  color: #fff;
  margin: 0 0 20px;
  letter-spacing: 4px;
  text-shadow: 0 3px 12px rgba(0, 0, 0, 0.25);
}

.hero-divider {
  width: 360px;
  height: 1px;
  background: linear-gradient(90deg, rgba(245, 208, 106, 0.8), transparent);
  margin-bottom: 20px;
}

.hero-en-title {
  font-size: 26px;
  color: rgba(255, 255, 255, 0.85);
  letter-spacing: 6px;
  font-weight: 400;
  margin: 0;
}

/* ===== 面包屑 ===== */
.breadcrumb-section {
  background: #f5f6f8;
  border-bottom: 1px solid #eaeaec;
}

.breadcrumb {
  padding: 18px 0;
  display: flex;
  align-items: center;
  gap: 14px;
  font-size: 14px;
}

.crumb-link {
  color: #666;
  text-decoration: none;
  padding: 2px 4px;
  transition: color 0.2s;

  &.active {
    color: #1a56db;
    border-bottom: 2px solid #1a56db;
    font-weight: 500;
  }
}

.crumb-sep { color: #ccc; }

.crumb-current {
  color: #333;
  border-bottom: 2px solid #1a56db;
  padding: 2px 4px;
  font-weight: 500;
}

/* ===== 内容区 ===== */
.content-section { padding: 60px 0 80px; }

/* 置顶文章 */
.featured-article {
  display: grid;
  grid-template-columns: 380px 1fr;
  background: #f5f6f8;
  border-radius: 2px;
  overflow: hidden;
  margin-bottom: 48px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  transition: box-shadow .35s ease, transform .35s ease;

  &:hover {
    box-shadow: 0 10px 30px rgba(0,0,0,0.08);
    transform: translateY(-2px);

    .image-shine { left: 120%; }
    .featured-btn { transform: translateX(4px); background: #b91c1c; }
  }
}

.featured-image {
  position: relative;
  height: 240px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    filter: saturate(1.05);
    transition: transform .7s ease, filter .7s ease;
  }

  &:hover img {
    transform: scale(1.06);
    filter: saturate(1.2);
  }
}

/* 图片光泽扫过效果 */
.image-shine {
  position: absolute;
  top: 0;
  left: -80%;
  width: 50%;
  height: 100%;
  background: linear-gradient(110deg, transparent 0%, rgba(255,255,255,0.4) 50%, transparent 100%);
  transform: skewX(-20deg);
  transition: left .9s ease;
  pointer-events: none;
}

.featured-content {
  padding: 40px 50px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.featured-title {
  font-size: 20px;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 16px;
  line-height: 1.4;
  transition: color .3s;
}

.featured-excerpt {
  font-size: 14px;
  color: #475569;
  line-height: 1.9;
  margin: 0 0 24px;
}

.featured-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.featured-date {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #64748b;
  i { font-size: 14px; }
}

.featured-btn {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: #dc2626;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.35s cubic-bezier(.2,.8,.2,1);
  box-shadow: 0 3px 10px rgba(220, 38, 38, 0.3);

  i { color: #fff; font-size: 14px; font-weight: bold; }

  &:hover { box-shadow: 0 6px 16px rgba(220,38,38,0.45); }
}

/* 文章列表 */
.article-list { display: flex; flex-direction: column; }

.article-item {
  display: grid;
  grid-template-columns: 100px 1fr 60px;
  gap: 32px;
  align-items: center;
  padding: 30px 0;
  border-bottom: 1px solid #eee;
  transition: background 0.3s ease, padding-left .3s ease;

  &:hover {
    background: #fafbfc;
    padding-left: 6px;

    .article-action {
      border-color: #dc2626;
      color: #dc2626;
      transform: translateX(4px) rotate(0deg);
    }

    .article-title { color: #dc2626; padding-left: 0; }

    .article-title::before {
      opacity: 1;
      transform: scaleX(1);
    }
  }

  &.first .article-date-block {
    background: #1a56db;
    color: #fff;
    .date-day { color: #fff; }
    .date-ym { color: rgba(255,255,255,0.8); border-top-color: rgba(255,255,255,0.3); }
  }
}

.article-date-block {
  width: 80px;
  background: #f3f4f6;
  text-align: center;
  padding: 16px 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: 4px;
  transition: background .3s ease, transform .3s ease;

  .article-item:hover & {
    transform: scale(1.04);
  }

  &.highlight {
    background: #1a56db;
    color: #fff;
    .date-day { color: #fff; }
    .date-ym { color: rgba(255,255,255,0.8); border-top-color: rgba(255,255,255,0.3); }
  }
}

.date-day {
  font-size: 40px;
  font-weight: 700;
  color: #1e293b;
  line-height: 1;
  transition: color .3s;
}

.date-ym {
  font-size: 13px;
  color: #64748b;
  padding-top: 8px;
  border-top: 1px solid #d1d5db;
  width: 100%;
  letter-spacing: 0.5px;
  transition: color .3s, border-color .3s;
}

.article-info { min-width: 0; }

.article-title {
  position: relative;
  font-size: 18px;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 10px;
  line-height: 1.4;
  transition: color .3s, padding-left .3s;
  padding-left: 14px;

  /* 左竖条装饰 */
  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%) scaleX(0);
    transform-origin: left;
    width: 4px;
    height: 60%;
    background: linear-gradient(180deg, #dc2626, #1a56db);
    border-radius: 2px;
    opacity: 0;
    transition: opacity .3s, transform .35s ease;
  }
}

.article-excerpt {
  font-size: 13px;
  color: #64748b;
  line-height: 1.8;
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  transition: color .3s;

  .article-item:hover & { color: #475569; }
}

.article-action {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 1.5px solid #bbb;
  color: #888;
  display: flex;
  align-items: center;
  justify-content: center;
  justify-self: end;
  transition: all 0.35s cubic-bezier(.2,.8,.2,1);
  cursor: pointer;

  i { font-size: 14px; font-weight: bold; }

  &.active {
    border-color: #dc2626;
    color: #dc2626;
    animation: pulseArrow 2.4s ease-in-out infinite;
  }
}

@keyframes pulseArrow {
  0%, 100% { box-shadow: 0 0 0 0 rgba(220, 38, 38, 0.18); }
  50% { box-shadow: 0 0 0 8px rgba(220, 38, 38, 0); }
}

/* 分页 */
.pagination-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  margin-top: 60px;
  flex-wrap: wrap;
}

.total-text {
  font-size: 14px;
  color: #475569;
  margin-right: 10px;
}

.page-btn, .page-num {
  min-width: 38px;
  height: 36px;
  padding: 0 14px;
  border: 1px solid #d1d5db;
  background: #fff;
  color: #475569;
  border-radius: 3px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.25s cubic-bezier(.2,.8,.2,1);
  position: relative;
  overflow: hidden;

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(135deg, #1a56db, #3b82f6);
    opacity: 0;
    transition: opacity .25s;
    z-index: 0;
  }

  &:hover:not(:disabled) {
    border-color: #1a56db;
    color: #fff;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(26,86,219,0.25);

    &::after { opacity: 1; }
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  span, & { z-index: 1; position: relative; }
}

.page-num {
  padding: 0;
  min-width: 36px;

  &.active {
    background: #1a56db;
    border-color: #1a56db;
    color: #fff;
    font-weight: 600;
    box-shadow: 0 3px 10px rgba(26,86,219,0.3);

    &::after { opacity: 0; }
  }
}

/* ===== 响应式 ===== */
@media (max-width: 992px) {
  .party-hero { height: 320px; }
  .hero-content { padding-left: 8%; }
  .hero-title { font-size: 42px; }
  .featured-article { grid-template-columns: 1fr; }
  .featured-image { height: 260px; }
  .featured-content { padding: 28px; }
  .article-item { grid-template-columns: 80px 1fr 50px; gap: 20px; }
}

@media (max-width: 768px) {
  .party-hero { height: 280px; }
  .hero-title { font-size: 34px; letter-spacing: 2px; }
  .hero-en-title { font-size: 18px; letter-spacing: 3px; }
  .hero-divider { width: 240px; }
  .content-section { padding: 40px 0 60px; }
  .featured-image { height: 200px; }
  .featured-content { padding: 22px; }
  .featured-title { font-size: 18px; }
  .article-item {
    grid-template-columns: 68px 1fr;
    grid-template-rows: auto auto;
    gap: 12px 16px;
    padding: 22px 0;
  }
  .article-date-block {
    width: 68px;
    padding: 12px 6px;
    grid-row: 1 / 3;
  }
  .date-day { font-size: 30px; }
  .article-title { font-size: 16px; }
  .article-action {
    grid-column: 2;
    justify-self: start;
    width: 32px;
    height: 32px;
  }
}

@media (max-width: 480px) {
  .party-hero { height: 220px; }
  .hero-content { padding-left: 5%; }
  .hero-title-bar { width: 50px; margin-bottom: 14px; }
  .hero-title { font-size: 28px; }
  .hero-divider { width: 160px; margin-bottom: 12px; }
  .hero-en-title { font-size: 14px; letter-spacing: 2px; }
  .featured-image { height: 180px; }
  .featured-content { padding: 18px 16px; }
  .featured-title { font-size: 16px; }
  .featured-excerpt { font-size: 13px; line-height: 1.7; margin-bottom: 16px; }
  .content-section { padding: 30px 0 50px; }
  .pagination-wrap { margin-top: 40px; gap: 6px; }
  .page-btn, .page-num {
    min-width: 32px; height: 32px; padding: 0 10px; font-size: 13px;
  }
}
</style>
